import { render, staticRenderFns } from "./bzbd.vue?vue&type=template&id=136cda6f&scoped=true&"
import script from "./bzbd.vue?vue&type=script&lang=js&"
export * from "./bzbd.vue?vue&type=script&lang=js&"
import style0 from "./bzbd.vue?vue&type=style&index=0&id=136cda6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136cda6f",
  null
  
)

export default component.exports